import { useDispatch } from "react-redux";
import { openTaskPopup, setNewTask } from "../../redux/taskSlice";
import { Button } from "../Buttons";

const TablesDropdown = ({
  showDropdown,
  setShowDropdown,
  disableBarButtons,
  handleDrpdnClick,
  versionHistoryHandler,
  dropdownRef,
  isAccessible = true,
  buttonStyle = {},
}) => {
  const dispatch = useDispatch();
  return (
    <div className="tables-dropdown" ref={dropdownRef}>
      <Button
        className="appbar-button tables-button"
        onClick={() => setShowDropdown(!showDropdown)}
        disabled={disableBarButtons}
        style={{
          opacity: disableBarButtons ? 0.5 : 1,
          cursor: disableBarButtons ? "not-allowed" : "pointer",
          ...buttonStyle
        }}
        variant="gray"
        size="sm"
      >
        Tables ▼
      </Button>
      {showDropdown && isAccessible && (
        <div className="dropdown-menu">
          <span
            className="dropdown-item"
            onClick={() => handleDrpdnClick("Items Table", "parts")}
          >
            Item Code Table
          </span>
          <span
            className="dropdown-item"
            onClick={() => {handleDrpdnClick("Type Table", "type")}}
          >
            Type Table
          </span>
          <span
            className="dropdown-item"
            onClick={() => handleDrpdnClick("Category Table", "category")}
          >
            Category Table
          </span>

            <span
            className="dropdown-item"
            // style={{ opacity: 0.5 , cursor:"not-allowed",}}
            onClick={() => {
              dispatch(openTaskPopup());
              dispatch(setNewTask(null));
              setShowDropdown(false);
            }}
            >
              Task List
            </span>
          
          <span
            className="dropdown-item"
            onClick={() => handleDrpdnClick("Project Table", "projects")}
          >
            Project ID Table
          </span>
          <span className="dropdown-item dropdown-item--disabled" aria-disabled="true">
            Training Log
          </span>
          {/* Version History Dropdown Item (disabled when no handler, e.g. add-section) */}
          <span
            style={{ opacity: 0.5, cursor: "not-allowed" }}
            // style={
            //   versionHistoryHandler
            //     ? undefined
            //     : { opacity: 0.5, cursor: "not-allowed" }
            // }
            className={
              versionHistoryHandler
                ? "dropdown-item"
                : "dropdown-item dropdown-item--disabled"
            }
            aria-disabled={!versionHistoryHandler}
            onClick={() => {
              // if (!versionHistoryHandler) return;
              // versionHistoryHandler();
              // setShowDropdown(false);
            }}
          >
            Version History
          </span>
        </div>
      )}
    </div>
  );
};

export default TablesDropdown;
